import type { ProgramType } from '@types/program';

const formatPrograms = (
  listPrograms: ProgramType[],
  categoryId = 'All',
  tier?: 'premium' | 'base' | null
) => {
  // don't display programs that are under Hide or Other categories
  const programsWithoutOtherHide = listPrograms?.filter(
    (program) => !program?.categories?.includes('Hide') && !program?.categories?.includes('Other')
  );
  // filter the specific tiering programs
  const tieredPrograms = tier
    ? programsWithoutOtherHide.filter((program) => program?.tiers?.includes(tier))
    : programsWithoutOtherHide;
  // filter the specific category programs
  const programsFilterByCategory =
    categoryId === 'All'
      ? tieredPrograms
      : tieredPrograms?.filter((program) => program?.categories?.includes(categoryId));
  // ascending by sortOrder; missing/null counts as 0; ties keep incoming order; input is not mutated
  return programsFilterByCategory
    ?.slice()
    .sort((a, b) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0));
};

export default formatPrograms;
